module.exports = __webpack_public_path__ + "img/relevador_de_seguridad.bf52dd30.jpg";